module.exports = __webpack_public_path__ + "img/11.7e301cae.png";